// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { IntegratorDTO } from '../models';
/**
 * IntegratorApi - axios parameter creator
 * @export
 */
export const IntegratorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch all integrators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrators(options: any = {}): RequestArgs {
            const localVarPath = `/v2/integrator`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegratorApi - functional programming interface
 * @export
 */
export const IntegratorApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Fetch all integrators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrators(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegratorDTO> {
            const localVarAxiosArgs = IntegratorApiAxiosParamCreator(configuration).getIntegrators(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * IntegratorApi - factory interface
 * @export
 */
export const IntegratorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Fetch all integrators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrators(options?: any) {
            return IntegratorApiFp(configuration).getIntegrators(options)(axios, basePath);
        },
    };
};

/**
 * IntegratorApi - interface
 * @export
 * @interface IntegratorApi
 */
export interface IntegratorApiInterface {
    /**
     * Fetch all integrators
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegratorApiInterface
     */
    getIntegrators(options?: any): AxiosPromise<IntegratorDTO>;

}

/**
 * IntegratorApi - object-oriented interface
 * @export
 * @class IntegratorApi
 * @extends {BaseAPI}
 */
export class IntegratorApi extends BaseAPI implements IntegratorApiInterface {
    /**
     * Fetch all integrators
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegratorApi
     */
    public getIntegrators(options?: any) {
        return IntegratorApiFp(this.configuration).getIntegrators(options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for IntegratorApi
 * Import individual functions for optimal bundle size
 */
/**
 * Fetch all integrators
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getIntegrators(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<IntegratorDTO> {
    const localVarAxiosArgs = IntegratorApiAxiosParamCreator(configuration).getIntegrators(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

